import { handleActions } from 'redux-actions';
import { reduxKey } from './constants';
import { UnreadChatsStoreSlice } from './types';
import { newChatMessage } from './actions';

const reducers = handleActions<UnreadChatsStoreSlice, any>(
  {
    [`${newChatMessage}`]: (state, action: ReturnType<typeof newChatMessage>) =>
      true,
  },
  false
);

export default {
  [reduxKey]: reducers,
};
